// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","line":"Footer_line__1Edn9","page-links":"Footer_page-links__3Aes9","copyright":"Footer_copyright__2wqDr"};